import backend from '@/services/backend'
// import store from '@/store'

export default {

    getUserList (authToken, realmName, studyName) {
        return backend.get('user/list/' + realmName + '/' + studyName, { headers: { Authorization: authToken }} )
    },

    getUserDetails (authToken, realmName, userId) {
        return backend.get('user/details/'+realmName+"/"+userId, { headers: { Authorization: authToken }} )
    },

    updateUserDetails (authToken, realmName, details, sendInvite) {
        const inviteParam = sendInvite ? "?invite=true" : "";
        return backend({ method: 'post', url: 'user/details/' + realmName + inviteParam, data: details, headers: { Authorization: authToken } })
    },

    updateUserSettings (authToken, realmName, details) {
        return backend({ method: 'post', url: 'user/settings/'+realmName, data: details, headers: { Authorization: authToken } })
    },


    getVariableSuggestions (authToken, realmName, studyName, varName, part) {
        return backend.get('user/variablesuggestions/'+realmName+'/'+studyName+"/"+varName+'/'+part, { headers: { Authorization: authToken }} )
    }

}
